<template>
  <div class="basic_wrap recharge-page">
    <div class="red_top_bg page-top">
      <div
        class="back_left"
        @click="$router.back()"
      />
      <div class="big_tit">
        {{ $t('moneybag.rechargeRecord') }}
      </div>
    </div>

    <section class="balance-card">
      <p>{{ $t('moneybag.accountBalance') }}</p>
      <strong>{{ utils_moneyMark() }} {{ funds.toFixed(2) }}</strong>
    </section>

    <div class="detail_box">
      <van-empty
        v-if="listShow"
        :description="$t('item.noData')"
      />
      <article
        v-for="(item, index) in data"
        v-else
        :key="item.id || item.orderid || index"
        class="record-card"
      >
        <div class="de_wrap">
          <div class="record-title">
            <span>{{ $t('invest_qrcode.recharge') }}</span>
            <strong
              class="record-status"
              :class="getRechargeStatusClass(item)"
            >
              {{ getRechargeStatusText(item) }}
            </strong>
          </div>
          <p
            v-if="item.memo"
            class="time memo"
          >
            {{ $t('cash.remark') }}: {{ item.memo }}
          </p>
          <p class="time">
            {{ item.orderid }}
          </p>
          <p class="time">
            {{ item.time }}
          </p>
        </div>
        <div
          class="price"
          :class="getRechargeAmountClass(item)"
        >
          {{ formatRechargeAmount(item) }}
        </div>
      </article>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { Empty } from "vant";
import Fetch from "../../utils/fetch";

Vue.use(Empty);

export default {
	name: "RechargeRecord",
	data() {
		return {
			lang: this.$i18n.locale || "zh_cn",
			data: [],
			list: {},
			account: 0,
			option: [],
			listShow: false,
			funds: 0,
			mymoney: 0,
			userName: "",
		};
	},
	created() {
		this.$parent.footer("user", false);
	},
	mounted() {
		Fetch("/user/funds", {
			reason_id: 1,
		}).then(r => {
			this.option.push({
				text: this.$t("moneybag.types"),
				value: 0,
			});

			this.mymoney = r.data.mymoney;
			this.funds = parseInt(r.data.money);
			this.userName = r.data.username;
		});

		Fetch("/user/recharge_search").then(r => {
			var list = r.data || [];

			this.showError(list.length);
			this.data = list;
		});
	},
	methods: {
		chooseType(val) {
			if (val == 0) {
				Fetch("/user/funds").then(r => {
					this.data = r.data.list;
					this.showError(r.data.list.length);
				});
			} else {
				Fetch("/user/funds", {
					reason_id: val,
				}).then(r => {
					this.data = r.data.list;
					this.showError(r.data.list.length);
				});
			}
		},
		formatRechargeAmount(item) {
			var amount = parseInt(item.money);

			if (isNaN(amount)) {
				amount = 0;
			}

			return this.utils_moneyMark() + amount;
		},
		getRechargeStatusText(item) {
			if (String(item.status) === "1") {
				return this.$t("invest.success");
			}
			if (String(item.status) === "2") {
				return this.$t("invest.failed");
			}
			return this.$t("invest_qrcode.submittedSuccessfully");
		},
		getRechargeStatusClass(item) {
			if (String(item.status) === "1") {
				return "is-success";
			}
			if (String(item.status) === "2") {
				return "is-fail";
			}
			return "is-pending";
		},
		getRechargeAmountClass(item) {
			if (String(item.status) === "1") {
				return "is-success";
			}
			if (String(item.status) === "2") {
				return "is-fail";
			}
			return "is-pending";
		},
		showError(len) {
			this.listShow = len === 0;
		},
	},
};
</script>

<style lang="less" scoped>
.recharge-page {
	min-height: 100vh;
	background: #fff;
	color: #16223a;
	padding-bottom: 80px;
	box-sizing: border-box;
}

.page-top {
	height: 44px;
	background: #fff;
	color: #16223a;
	border-bottom: 1px solid rgba(240, 242, 245, 1);
	box-sizing: border-box;

	.back_left {
		opacity: 0.88;
	}

	.big_tit {
		color: #16223a;
	}
}

.balance-card {
	margin: 16px 16px 0;
	padding: 20px 18px;
	border-radius: 14px;
	border: 1px solid rgba(255, 93, 122, 0.16);
	background: #fff;
	box-shadow: 0 12px 22px rgba(22, 34, 58, 0.08);
	text-align: center;
	box-sizing: border-box;
}

.balance-card p {
	color: #6d7688;
	font-size: 14px;
	line-height: 20px;
}

.balance-card strong {
	display: block;
	margin-top: 10px;
	color: #ff5d7a;
	font-size: 20px;
	font-weight: 700;
	line-height: 28px;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.detail_box {
	padding: 16px 16px 0;
}

.record-card {
	margin-bottom: 14px;
	padding: 17px 18px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	border-radius: 14px;
	border: 1px solid rgba(255, 93, 122, 0.16);
	background: #fff;
	box-shadow: 0 12px 22px rgba(22, 34, 58, 0.08);
	box-sizing: border-box;
}

.de_wrap {
	min-width: 0;
	flex: 1;
}

.record-title {
	display: flex;
	align-items: center;
	min-width: 0;
}

.record-title span {
	min-width: 0;
	color: #16223a;
	font-size: 14px;
	font-weight: 700;
	line-height: 22px;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.record-status {
	flex: 0 0 auto;
	margin-left: 8px;
	font-size: 12px;
	line-height: 18px;
	white-space: nowrap;
}

.time {
	margin-top: 8px;
	color: #6d7688;
	font-size: 12px;
	line-height: 18px;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.memo {
	white-space: normal;
	word-break: break-word;
}

.price {
	flex: 0 0 auto;
	max-width: 38%;
	margin-left: 14px;
	font-size: 16px;
	font-weight: 700;
	line-height: 24px;
	text-align: right;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.is-success {
	color: #12ed72;
}

.is-fail {
	color: #ff4a4a;
}

.is-pending {
	color: #ff5d7a;
}

/deep/ .van-empty {
	padding-top: 72px;
}

/deep/ .van-empty__description {
	color: #9aa1aa;
}

@media screen and (max-width: 374px) {
	.balance-card,
	.detail_box {
		margin-right: 12px;
		margin-left: 12px;
	}

	.detail_box {
		padding-right: 0;
		padding-left: 0;
	}

	.record-card {
		padding-right: 14px;
		padding-left: 14px;
	}

	.price {
		max-width: 34%;
		font-size: 14px;
	}
}

.recharge-page {
	min-height: 100vh;
	padding-bottom: calc(84px + env(safe-area-inset-bottom));
	background: #201c1d;
	color: #f4ece7;
}

.page-top {
	background: #201c1d;
	color: #f3c99e;
	border-bottom-color: #302723;
}

.page-top .back_left {
	opacity: 1;
	filter: brightness(0) saturate(100%) invert(86%) sepia(18%) saturate(702%) hue-rotate(333deg) brightness(99%) contrast(92%);
}

.page-top .big_tit {
	color: #f3c99e;
}

.balance-card {
	margin: 14px 10px 0;
	padding: 18px 14px;
	border: 1px solid #75654f;
	border-radius: 9px;
	background: linear-gradient(120deg, #302923, #292727);
	box-shadow: 0 10px 24px rgba(0, 0, 0, .2);
}

.balance-card p {
	color: #c7af99;
}

.balance-card strong {
	color: #f3c99e;
}

.detail_box {
	padding: 12px 10px 0;
}

.record-card {
	margin-bottom: 10px;
	padding: 14px;
	border: 1px solid #75654f;
	border-radius: 9px;
	background: linear-gradient(110deg, #232323, #303030);
	box-shadow: 0 8px 18px rgba(0, 0, 0, .17);
}

.record-title span {
	color: #f4ece7;
	font-weight: 500;
}

.time {
	color: #bda895;
}

.is-success {
	color: #a9d6a4;
}

.is-fail {
	color: #ee8c83;
}

.is-pending {
	color: #f3c99e;
}

/deep/ .van-empty__description {
	color: #b28d6c;
}

@media screen and (max-width: 374px) {
	.balance-card {
		margin-right: 8px;
		margin-left: 8px;
	}

	.detail_box {
		margin: 0;
		padding-right: 8px;
		padding-left: 8px;
	}
}
</style>
